import type { BrandKit } from '../brand.types'
import { primary, secondary } from '@/styles/palette'
import logo from '@/assets/brands/homely-md/logo.png'
import favicon from '@/assets/icons/logo-fevicon.png'
import { ENV } from '@/config'

/**
 * White-label kit with its own logo and palette.
 *
 * Colours are the magenta/purple this branch keeps in `styles/palette.ts`,
 * read from there exactly as the default kit does so the two cannot drift.
 *
 * The mark is `images/homely_logo.png` cropped to its wordmark. The source
 * is a 1280x1280 canvas with the wordmark on ~15% of its height, so at the
 * login banner's 72px it rendered ~11px of logo — which is why the branch
 * used to hide it there and show it at 160px on the form instead. Cropping
 * is not recolouring; the artwork is untouched.
 *
 * The wordmark is itself magenta-to-purple, so on the brand surface it sits
 * on a white plate rather than vanishing into the gradient.
 *
 * No favicon of its own exists yet; the platform one is kept, as before.
 */
export const homelyMdBrand: BrandKit = {
  id: 'homely-md',
  name: ENV.APP_NAME,

  logo,
  logoOnBrand: logo,
  logoOnBrandPlate: true,
  favicon,

  palette: {
    primary: {
      main: primary.main,
      dark: primary.dark,
      light: primary.light,
      lighter: primary[30],
      contrastText: primary.contrastText,
    },
    secondary: {
      main: secondary.main,
      dark: secondary.dark,
      light: secondary.light,
      lighter: secondary[30],
      contrastText: secondary.contrastText,
    },
  },

  brandSurface: `linear-gradient(135deg, ${primary.dark} 0%, ${primary.main} 100%)`,
}
